import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import Help from '../../../generics/help';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../../config');
var report = require('../../../generics/report_head');

class NurseProductivity extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);

		this.setTable = this.setTable.bind(this);
		this.dateCompare = this.dateCompare.bind(this);

		this.state = {
			health_facilities_id:"",

			listado:[],
			start_date 	:"",
            end_date 	:"",
            staff:[],
            medical_staff_id:"all",

			//test datatable to export
			columns:[
				{title:'Nombre enfermera'},
				{title: 'Cantidad de ST'},
				{title: 'Cantidad de AF'},
			],
			filename:"Productividad Extracción",
			
			totales:[],
			date_hour:"",
			medical:"",
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}
	}

	componentDidMount(){
		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)
		
		fetch(Config.default.apiGateway.URL+'medical_staff?option=mainInfo&type=NURSE', {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					staff: response
				});
			}
		});

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split("/");
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				start_date:date[2]+'-'+date[1]+'-'+date[0],
				end_date:date[2]+'-'+date[1]+'-'+date[0],
				date_hour:aux[0]+' '+hours,
			});
		})

		this.setTable();
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}


 	setTable(){
 		var fechas = "Información Del: "+moment(this.state.start_date).format("DD/MM/YYYY")+ 
					" Al: "+moment(this.state.end_date).format("DD/MM/YYYY");
		this.$el = $(this.el);

		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			buttons: [
				{
                	extend: 'excelHtml5',
                	title: this.state.filename
            	},
               	{
                	extend: 'pdf',
                	title: this.state.filename,
                	pageSize: 'A4',
                	customize: (doc)=> { 
                		doc.content.unshift({
							image: this.props.header_document,
							alignment:'center',
							width:this.props.w_head
						});
						doc.content.splice(2, 0, {text: fechas, margin:[10,0,0,10] });

						var i_table = 3;
						
            			doc.content[i_table].table.widths=["50%","25%","25%"];
            			
            			doc.content[i_table].table.body.map((b, i)=>{
                			b.map((t, j)=>{
                				if(j > 0){
                					t.alignment = 'right';
                				}
                			})
                        })
                        
                        doc.content.push({
                            text: 'ST: '+(this.state.totales.tot_st !== undefined ? ' '+this.state.totales.tot_st : "")+'\t  '+
                                    'AF: '+(this.state.totales.tot_af !== undefined ? ' '+this.state.totales.tot_af : "")+'\t  ',
                            margin:[10, 10, 0, 0]
                        })

                		doc.defaultStyle.fontSize = 6.5;
                		doc.styles.tableHeader.fontSize = 6.5;
                		doc.footer = {text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]};
                	}
            	}
            ],
			columnDefs: [{
		        targets: [1,2],
		        className: 'dt-right'
    		}],
			data: this.state.listado,
			columns:this.state.columns,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"fnInfoCallback":null,
			},
			paging:false,
			responsive:true,
			searching: false,
			scrollY:"32em",
			scrollX: true,
			autoWidth: false,
			info:false,
			ordering:false,
			createdRow: function(row, data, dataIndex){
				if(data[0] === 'TOTAL'){
			        $('td', row).attr('style', 'text-align:right; font-weight:bold');
				}

				return row;
            }
		});

		if (table.rows().indexes().length === 0 ) {
			table.buttons('.buttons-html5').disable();
		}else {
			table.buttons('.buttons-html5').enable();
		}
	}

	handleChange(e){
		
		this.setState({
			[e.target.name]: e.target.value
		});

		if(document.getElementById(e.target.name).className.includes('error')){
			document.getElementById(e.target.name).classList.remove('error');
		}

	}

	searching(){
		if(this.isValidForm()){
			if(this.dateCompare()){
				this.props.waiting.handleShow('Buscando...');

				var obj = {
					medical_staff_id: this.state.medical_staff_id,
					start_date: this.state.start_date,
					end_date: this.state.end_date,
					health_facilities_id:this.state.health_facilities_id
				}
				
				fetch(Config.default.apiGateway.URL+'reports/nurse_productivity',{
					method: 'POST',
					body:JSON.stringify(obj),
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						this.props.waiting.handleClose();
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
				
				if(response !== undefined){
					this.setState({
						listado: [],
					});

					var list = [];
					response.resp.map((res)=>{
                        list.push([
                            res.nurse,
                            res.tot_st,
                            res.tot_af
                        ])
                    })

					this.setState({
						listado: list,
						
						totales:response.totals
					});

					setTimeout(()=>{
						this.props.waiting.handleShow('Cargando...');
						this.$el = $(this.el);
						this.$el.DataTable().destroy();
						this.$el.empty();
					}, 500);

					setTimeout(()=>{
						this.props.waiting.handleClose();
						this.setTable();
					}, 1000);
				
						
					this.props.waiting.handleClose();
				}
				});		
			}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;

		if(ini !== 'Invalid date' && fin !== 'Invalid date'){
			if(fin < ini){
				date_ok = false;
				document.getElementById('end_date').classList.add('error');
			}else{
				document.getElementById('end_date').classList.remove('error');
			}
		}else{
			date_ok = false;
		}		

		return date_ok;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					Donantes ->
					{this.state.filename}
					</h5>
				</div>
				
				<Help 
					{...this.props}
		            menu={"help_donors"} 
		            submenu={"help_nurse_productivity"}  />
				<div className="form-group" style={{paddingLeft:"0.5em"}}>
					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
								<div className="form-group">
									<span className="span-min">Fecha Desde</span>
									<input type="date" className="form-control hour-input" name="start_date" id="start_date"
										value={this.state.start_date} onChange={this.handleChange} required />
								</div>
								<div className="form-group">
									<span className="span-min">Fecha Hasta</span>
									<input type="date" className="form-control hour-input" name="end_date" id="end_date"
										value={this.state.end_date} onChange={this.handleChange} required />
								</div>
                                <div className="form-group">
									<span className="span-min">Personal</span>
									<select className="form-control" name="medical_staff_id" id="medical_staff_id"
										value={this.state.medical_staff_id} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
                                        <option value="all">Todos</option>
                                        {this.state.staff.map((t)=> (
                                            <option key={t.medical_staff.id} value={t.medical_staff.id} >
                                                {t.medical_staff.code?t.medical_staff.code+' - ':""} 
                                                {' '+t.medical_staff.names+' '} 
                                                {t.medical_staff.lastname1?t.medical_staff.lastname1+' ': ""} 
                                                {t.medical_staff.lastname2?t.medical_staff.lastname2: ""}
                                            </option>
                                        ))}
									</select>
								</div>

								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12">
									<div className="col-xs-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline", fontSize:'16px'}}>
										<span>
											{this.state.filename}
										</span>
									</div>
									<div className="col-xs-12">
										<span>
											Información Del:   {moment(this.state.start_date).format('DD/MM/YYYY')}
										</span>
										<span style={{marginLeft:"5px"}}>	
											Al: {moment(this.state.end_date).format('DD/MM/YYYY')} 
										</span>
									</div>
								</div>
								
								<div className="col-xs-12" id="table-to-pdf">
									<div className="table-responsive">
										<table style={{fontSize:"11px"}}  id="table-to-xls" width="100%" ref={el => this.el = el}>
										</table>
									</div>
								</div>
								<div className="col-xs-12">
                                    <label>ST: </label>
                                    <span>{this.state.totales.tot_st !== undefined ? ' '+this.state.totales.tot_st : ""}</span>
                                    <label style={{marginLeft:8}}>AF: </label>
                                    <span>{this.state.totales.tot_af !== undefined ? ' '+this.state.totales.tot_af : ""}</span>
                                </div>
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}
export default translate('translations')(NurseProductivity)